import React, { useEffect, useState } from "react";
import Header from "./Header";
import Footer from "./Footer";

import axios from "axios";
import Swal from "sweetalert2";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

import config from "../../config";

const Warehouse = () => {
  /* =========================================================
     USER
  ========================================================= */

  const userDetail = localStorage.getItem("ship_rocket_user");

  let userData = {};

  try {
    if (userDetail) {
      userData = JSON.parse(userDetail);
    }
  } catch (error) {
    console.error("Unable to parse user data", error);
  }

  const customerId = userData?.customer_id || "";

  /* =========================================================
     STATES
  ========================================================= */

  const [addressState, setAddressState] = useState([]);

  const [loading, setLoading] = useState(false);
  const [openActionId, setOpenActionId] = React.useState(null);
  const [createLoading, setCreateLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);

  const [modalState, setModalState] = useState({
    show: false,
  });

  const [editModal, setEditModal] = useState({
    show: false,
  });

  const [countryId, setCountryId] = useState(244);

  /* =========================================================
     CREATE FORM
  ========================================================= */

  const initialCreateForm = {
    full_name: "",
    country_name: 244,
    state_name: "",
    city_name: "",
    pincode: "",
    address: "",
    email: "",
    mobile: "",
    warehouse_name: "",
    err: {},
  };

  const [createForm, setCreateForm] = useState(initialCreateForm);

  const [createLocation, setCreateLocation] = useState({
    state: "",
    city: "",
    state_id: "",
    city_id: "",
    pincode: "",
  });

  /* =========================================================
     EDIT FORM
  ========================================================= */

  const initialEditForm = {
    show: false,
    full_name: "",
    country_name: "",
    state_name: "",
    city_name: "",
    pincode: "",
    address: "",
    email: "",
    mobile: "",
    address_id: "",
    country_id: 244,
    state_id: "",
    city_id: "",
    warehouse_name: "",
    err: {},
  };

  const [editForm, setEditForm] = useState(initialEditForm);

  const [editLocation, setEditLocation] = useState({
    state: "",
    city: "",
    state_id: "",
    city_id: "",
    pincode: "",
  });

  /* =========================================================
     INITIAL LOAD
  ========================================================= */

  useEffect(() => {
    getCountryList();
    addressBookDetail();
  }, []);

  /* =========================================================
     SWEET ALERT
  ========================================================= */

  const showToast = (title, success = true) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "bottom-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
    });

    Toast.fire({
      background: success ? "#3659cd" : "#a61c09",
      color: "white",
      icon: success ? "success" : "error",
      title,
    });
  };
  const toggleActionMenu = (addressId) => {
    setOpenActionId((prev) => (prev === addressId ? null : addressId));
  };

  /* =========================================================
     COUNTRY
  ========================================================= */

  const getCountryList = async () => {
    try {
      const url = `${config.apiUrl}/country/country_list`;

      const response = await axios.post(
        url,
        {},
        {
          headers: config.headers,
        }
      );

      if (response?.data?.defaultCountry) {
        const defaultCountry = response.data.defaultCountry;

        setCountryId(defaultCountry);

        setCreateForm((prev) => ({
          ...prev,
          country_name: defaultCountry,
        }));
      }
    } catch (error) {
      console.error("getCountryList error:", error);

      // Keep India as fallback because the existing API
      // was using country ID 244.
      setCountryId(244);

      setCreateForm((prev) => ({
        ...prev,
        country_name: 244,
      }));
    }
  };

  /* =========================================================
     GET WAREHOUSE LIST
  ========================================================= */

  const addressBookDetail = async () => {
    if (!customerId) {
      console.error("Customer ID not found");
      return;
    }

    try {
      setLoading(true);

      const url = `${config.apiUrl}/country/address_book`;

      const sendData = {
        customer_id: customerId,
      };

      const response = await axios.post(url, sendData, {
        headers: config.headers,
      });

      if (response?.data?.status === true) {
        setAddressState(response.data.output || []);
      } else {
        setAddressState([]);
      }
    } catch (error) {
      console.error("addressBookDetail error:", error);

      showToast("Unable to load warehouse list", false);
    } finally {
      setLoading(false);
    }
  };

  /* =========================================================
     CREATE FORM CHANGE
  ========================================================= */

  const handleCreateChange = (event) => {
    const { name, value } = event.target;

    setCreateForm((prev) => ({
      ...prev,
      [name]: value,
      err: {
        ...prev.err,
        [name]: false,
      },
    }));
  };

  /* =========================================================
     EDIT FORM CHANGE
  ========================================================= */

  const handleEditChange = (event) => {
    const { name, value } = event.target;

    setEditForm((prev) => ({
      ...prev,
      [name]: value,
      err: {
        ...prev.err,
        [name]: false,
      },
    }));
  };

  /* =========================================================
     PINCODE DETAILS
  ========================================================= */

  const fetchDetailsFromPincode = async (enteredPincode) => {
    try {
      if (!enteredPincode || enteredPincode.length < 3) {
        return {
          state: "",
          city: "",
          state_id: "",
          city_id: "",
        };
      }

      const url = `${config.apiUrl}/country/automate_pincode`;

      const sendData = {
        enteredPincode,
        country_id: countryId || 244,
      };

      const response = await axios.post(url, sendData, {
        headers: config.headers,
      });

      return {
        state: response?.data?.state || "",
        city: response?.data?.city || "",
        state_id: response?.data?.state_id || "",
        city_id: response?.data?.city_id || "",
      };
    } catch (error) {
      console.error("fetchDetailsFromPincode error:", error);

      return {
        state: "",
        city: "",
        state_id: "",
        city_id: "",
      };
    }
  };

  /* =========================================================
     CREATE PINCODE CHANGE
  ========================================================= */

  const handleCreatePincodeChange = async (event) => {
    const value = event.target.value.replace(/\D/g, "").slice(0, 6);

    setCreateForm((prev) => ({
      ...prev,
      pincode: value,
      state_name: "",
      city_name: "",
      err: {
        ...prev.err,
        pincode: false,
      },
    }));

    setCreateLocation({
      state: "",
      city: "",
      state_id: "",
      city_id: "",
      pincode: value,
    });

    if (value.length < 3) {
      return;
    }

    const details = await fetchDetailsFromPincode(value);

    setCreateLocation({
      state: details.state,
      city: details.city,
      state_id: details.state_id,
      city_id: details.city_id,
      pincode: value,
    });

    setCreateForm((prev) => ({
      ...prev,
      pincode: value,
      state_name: details.state_id,
      city_name: details.city_id,
    }));
  };

  /* =========================================================
     EDIT PINCODE CHANGE
  ========================================================= */

  const handleEditPincodeChange = async (event) => {
    const value = event.target.value.replace(/\D/g, "").slice(0, 6);

    setEditForm((prev) => ({
      ...prev,
      pincode: value,
      state_name: "",
      city_name: "",
      state_id: "",
      city_id: "",
      err: {
        ...prev.err,
        pincode: false,
      },
    }));

    setEditLocation({
      state: "",
      city: "",
      state_id: "",
      city_id: "",
      pincode: value,
    });

    if (value.length < 3) {
      return;
    }

    const details = await fetchDetailsFromPincode(value);

    setEditLocation({
      state: details.state,
      city: details.city,
      state_id: details.state_id,
      city_id: details.city_id,
      pincode: value,
    });

    setEditForm((prev) => ({
      ...prev,
      pincode: value,
      state_name: details.state_id,
      city_name: details.city_id,
      state_id: details.state_id,
      city_id: details.city_id,
    }));
  };

  /* =========================================================
     VALIDATION
  ========================================================= */

  const emailRegex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const addressPattern = /\d+/;

  const validateForm = (form) => {
    const errors = {};

    if (!form.full_name?.trim()) {
      errors.full_name = true;
    }

    if (!form.pincode || form.pincode.length !== 6) {
      errors.pincode = true;
    }

    if (!form.state_name) {
      errors.state = true;
    }

    if (!form.city_name) {
      errors.city = true;
    }

    if (!form.address?.trim()) {
      errors.address = true;
    } else if (!addressPattern.test(form.address)) {
      errors.address = true;
    }

    if (!form.email?.trim() || !emailRegex.test(form.email)) {
      errors.email = true;
    }

    if (!form.mobile || !/^[0-9]{10}$/.test(String(form.mobile))) {
      errors.mobile = true;
    }

    return errors;
  };

  /* =========================================================
     CREATE WAREHOUSE
  ========================================================= */

  const addAddress = async () => {
    const errors = validateForm(createForm);

    if (Object.keys(errors).length > 0) {
      setCreateForm((prev) => ({
        ...prev,
        err: errors,
      }));

      showToast("Please fill all the details correctly", false);

      return;
    }

    try {
      setCreateLoading(true);

      const url = `${config.apiUrl}/country/add_address_book`;

      const addstate = {
        ...createForm,
        country_name: countryId || 244,
        state_name: createLocation.state_id || createForm.state_name,
        city_name: createLocation.city_id || createForm.city_name,
        pincode: createForm.pincode,
      };

      const sendData = {
        addstate,
        customer_id: customerId,
      };

      const response = await axios.post(url, sendData, {
        headers: config.headers,
      });

      if (response?.data?.status === true) {
        showToast(
          response?.data?.message || "Warehouse Added Successfully",
          true
        );

        closeCreateModal();

        await addressBookDetail();
      } else {
        showToast(
          response?.data?.message || "Unable to create warehouse",
          false
        );
      }
    } catch (error) {
      console.error("addAddress error:", error);

      showToast(
        error?.response?.data?.message || "Something went wrong",
        false
      );
    } finally {
      setCreateLoading(false);
    }
  };

  /* =========================================================
     OPEN EDIT
  ========================================================= */

  const setEditAddress = async (warehouse) => {
    const editData = {
      show: true,

      address_id: warehouse.address_id,

      full_name: warehouse.full_name || "",

      country_name:
        warehouse.country_name || warehouse.country_id || countryId || 244,

      state_name: warehouse.state_id || warehouse.state_name || "",

      city_name: warehouse.city_id || warehouse.city_name || "",

      pincode: warehouse.pincode || "",

      address: warehouse.address || "",

      email: warehouse.email || "",

      mobile: warehouse.mobile || "",

      country_id: warehouse.country_id || countryId || 244,

      state_id: warehouse.state_id || "",

      city_id: warehouse.city_id || "",

      warehouse_name: warehouse.warehouse_id || "",

      err: {},
    };

    setEditForm(editData);

    /*
      Show the existing state/city immediately.
      Then if pincode exists, call API to make sure
      state/city are synchronized with pincode.
    */

    setEditLocation({
      state: warehouse.state_name || "",
      city: warehouse.city_name || "",
      state_id: warehouse.state_id || "",
      city_id: warehouse.city_id || "",
      pincode: warehouse.pincode || "",
    });

    if (warehouse.pincode) {
      const details = await fetchDetailsFromPincode(warehouse.pincode);

      if (details.state || details.city) {
        setEditLocation({
          state: details.state,
          city: details.city,
          state_id: details.state_id,
          city_id: details.city_id,
          pincode: warehouse.pincode,
        });

        setEditForm((prev) => ({
          ...prev,
          state_name: details.state_id || prev.state_name,
          city_name: details.city_id || prev.city_name,
          state_id: details.state_id || prev.state_id,
          city_id: details.city_id || prev.city_id,
        }));
      }
    }
  };

  /* =========================================================
     EDIT WAREHOUSE
  ========================================================= */

  const editAddress = async () => {
    const errors = validateForm(editForm);

    if (Object.keys(errors).length > 0) {
      setEditForm((prev) => ({
        ...prev,
        err: errors,
      }));

      showToast("Please fill all the details correctly", false);

      return;
    }

    try {
      setEditLoading(true);

      const url = `${config.apiUrl}/country/edit_address_book`;

      const editmodal = {
        ...editForm,

        show: undefined,

        country_name: editForm.country_id || countryId || 244,

        state_name:
          editLocation.state_id || editForm.state_id || editForm.state_name,

        city_name:
          editLocation.city_id || editForm.city_id || editForm.city_name,

        pincode: editForm.pincode,
      };

      const sendData = {
        editmodal,
        customer_id: customerId,

        city: editLocation.city || "",
        state: editLocation.state || "",

        pincode: editForm.pincode,

        city_id: editLocation.city_id || editForm.city_id || editForm.city_name,

        state_id:
          editLocation.state_id || editForm.state_id || editForm.state_name,
      };

      const response = await axios.post(url, sendData, {
        headers: config.headers,
      });

      if (response?.data?.status === true) {
        showToast(
          response?.data?.message || "Warehouse Updated Successfully",
          true
        );

        closeEditModal();

        await addressBookDetail();
      } else {
        showToast(
          response?.data?.message || "Unable to update warehouse",
          false
        );
      }
    } catch (error) {
      console.error("editAddress error:", error);

      showToast(
        error?.response?.data?.message || "Something went wrong",
        false
      );
    } finally {
      setEditLoading(false);
    }
  };

  /* =========================================================
     DELETE WAREHOUSE
  ========================================================= */

  const deleteAddressBook = async (addressId) => {
    const result = await Swal.fire({
      title: "Delete Warehouse?",
      text: "Are you sure you want to delete this warehouse?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Delete",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
    });

    if (!result.isConfirmed) {
      return;
    }

    try {
      const url = `${config.apiUrl}/country/delete_address_book`;

      const sendData = {
        customer_id: customerId,
        address_id: addressId,
      };

      const response = await axios.post(url, sendData, {
        headers: config.headers,
      });

      if (response?.data?.status === true) {
        showToast(
          response?.data?.message || "Warehouse Deleted Successfully",
          true
        );

        await addressBookDetail();
      } else {
        showToast(
          response?.data?.message || "Unable to delete warehouse",
          false
        );
      }
    } catch (error) {
      console.error("deleteAddressBook error:", error);

      showToast("Something went wrong", false);
    }
  };

  /* =========================================================
     MARK PRIMARY
  ========================================================= */

  const setAsPrimary = async (addressId) => {
    try {
      const url = `${config.apiUrl}/country/update_address_book_primary_status`;

      const sendData = {
        customer_id: customerId,
        address_id: addressId,
      };

      const response = await axios.post(url, sendData, {
        headers: config.headers,
      });

      if (response?.data?.status === true) {
        showToast(response?.data?.message || "Primary Warehouse Updated", true);

        await addressBookDetail();
      } else {
        showToast(
          response?.data?.message || "Unable to update primary warehouse",
          false
        );
      }
    } catch (error) {
      console.error("setAsPrimary error:", error);

      showToast("Something went wrong", false);
    }
  };

  /* =========================================================
     MODAL FUNCTIONS
  ========================================================= */

  const openCreateModal = () => {
    setCreateForm({
      ...initialCreateForm,
      country_name: countryId || 244,
    });

    setCreateLocation({
      state: "",
      city: "",
      state_id: "",
      city_id: "",
      pincode: "",
    });

    setModalState({
      show: true,
    });
  };

  const closeCreateModal = () => {
    setModalState({
      show: false,
    });

    setCreateForm({
      ...initialCreateForm,
      country_name: countryId || 244,
    });

    setCreateLocation({
      state: "",
      city: "",
      state_id: "",
      city_id: "",
      pincode: "",
    });
  };

  const closeEditModal = () => {
    setEditModal({
      show: false,
    });

    setEditForm({
      ...initialEditForm,
    });

    setEditLocation({
      state: "",
      city: "",
      state_id: "",
      city_id: "",
      pincode: "",
    });
  };

  /* =========================================================
     BACK
  ========================================================= */

  const goBack = () => {
    window.history.back();
  };

  /* =========================================================
     RENDER
  ========================================================= */

  return (
    <div>
      <Header>
        <div className="content">
          {/* =====================================================
              MOBILE HEADER
          ===================================================== */}

          <div className="mob_nav">
            <div className="row">
              <div className="col-7">
                <div className="d-flex justify-content-start align-items-center">
                  <a href="javascript:window.history.back();" class="back_btn">
                    <i class="bi bi-arrow-left"></i>
                  </a>

                  <h2>Warehouse</h2>
                </div>
              </div>

              <div className="col">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={openCreateModal}
                >
                  Create Warehouse
                </button>
              </div>
            </div>
          </div>

          {/* =====================================================
              DESKTOP HEADER
          ===================================================== */}

          <div className="row justify-content-between desk_nav">
            <div className="col-12 col-md-4">
              <div className="d-flex align-items-center">
                <a href="javascript:window.history.back();" class="back_btn">
                  <i class="bi bi-arrow-left"></i>
                </a>

                <h2 className="mb-0">Warehouse</h2>
              </div>
            </div>

            <div className="col-12 col-md-4 mb-3">
              <div className="row justify-content-end">
                <div className="col-6 col-md-6">
                  <div className="d-grid">
                    <button
                      type="button"
                      className="btn btn-primary btn-block"
                      onClick={openCreateModal}
                    >
                      <i className="bi bi-plus"></i> Create Warehouse
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* =====================================================
              CREATE WAREHOUSE MODAL
          ===================================================== */}

          <Modal
            show={modalState.show}
            onHide={closeCreateModal}
            size="lg"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Create Warehouse</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              {/* Warehouse Name */}

              <div className="row">
                <div className="col-12 col-md-6">
                  <label className="form-label">
                    Warehouse Name <span className="text-danger">*</span>
                  </label>

                  <input
                    type="text"
                    className={`form-control ${
                      createForm.err.full_name ? "is-invalid" : ""
                    }`}
                    placeholder="Enter Warehouse Name"
                    name="full_name"
                    value={createForm.full_name}
                    autoComplete="off"
                    onChange={handleCreateChange}
                  />

                  {createForm.err.full_name && (
                    <small className="text-danger">
                      Warehouse name is required.
                    </small>
                  )}
                </div>
              </div>

              {/* Pincode */}

              <div className="row mt-3">
                <div className="col-12 col-md-4 mb-3">
                  <label className="form-label">
                    Pincode <span className="text-danger">*</span>
                  </label>

                  <input
                    type="text"
                    className={`form-control ${
                      createForm.err.pincode ? "is-invalid" : ""
                    }`}
                    placeholder="Enter Pincode"
                    value={createForm.pincode}
                    maxLength={6}
                    onChange={handleCreatePincodeChange}
                  />

                  {createForm.err.pincode && (
                    <small className="text-danger">
                      Please enter a valid 6 digit pincode.
                    </small>
                  )}
                </div>

                <div className="col-6 col-md-4 mb-3">
                  <label className="form-label">State</label>

                  <input
                    type="text"
                    className={`form-control ${
                      createForm.err.state ? "is-invalid" : ""
                    }`}
                    value={createLocation.state}
                    disabled
                    placeholder="State"
                  />
                </div>

                <div className="col-6 col-md-4 mb-3">
                  <label className="form-label">City</label>

                  <input
                    type="text"
                    className={`form-control ${
                      createForm.err.city ? "is-invalid" : ""
                    }`}
                    value={createLocation.city}
                    disabled
                    placeholder="City"
                  />
                </div>
              </div>

              {/* Address */}

              <div className="row mt-1">
                <div className="col-12">
                  <label className="form-label">
                    Address <span className="text-danger">*</span>
                  </label>

                  <input
                    type="text"
                    className={`form-control ${
                      createForm.err.address ? "is-invalid" : ""
                    }`}
                    placeholder="Enter Address"
                    name="address"
                    value={createForm.address}
                    autoComplete="off"
                    onChange={handleCreateChange}
                  />

                  {createForm.err.address && (
                    <small className="text-danger">
                      Address must contain house/block/building/street number.
                    </small>
                  )}
                </div>
              </div>

              {/* Email + Mobile */}

              <div className="row mt-3">
                <div className="col-12 col-md-6">
                  <label className="form-label">
                    Email <span className="text-danger">*</span>
                  </label>

                  <input
                    type="email"
                    className={`form-control ${
                      createForm.err.email ? "is-invalid" : ""
                    }`}
                    placeholder="Enter Email"
                    name="email"
                    value={createForm.email}
                    autoComplete="off"
                    onChange={handleCreateChange}
                  />

                  {createForm.err.email && (
                    <small className="text-danger">
                      Please enter a valid email.
                    </small>
                  )}
                </div>

                <div className="col-12 col-md-6">
                  <label className="form-label">
                    Mobile # <span className="text-danger">*</span>
                  </label>

                  <input
                    type="text"
                    inputMode="numeric"
                    className={`form-control ${
                      createForm.err.mobile ? "is-invalid" : ""
                    }`}
                    placeholder="Enter Mobile Number"
                    name="mobile"
                    value={createForm.mobile}
                    maxLength={10}
                    autoComplete="off"
                    onChange={handleCreateChange}
                  />

                  {createForm.err.mobile && (
                    <small className="text-danger">
                      Please enter a valid 10 digit mobile number.
                    </small>
                  )}
                </div>
              </div>
            </Modal.Body>

            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={closeCreateModal}
                disabled={createLoading}
              >
                Cancel
              </Button>

              <Button
                variant="primary"
                onClick={addAddress}
                disabled={createLoading}
              >
                {createLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                    ></span>
                    Creating...
                  </>
                ) : (
                  "Create Warehouse"
                )}
              </Button>
            </Modal.Footer>
          </Modal>

          {/* =====================================================
              EDIT WAREHOUSE MODAL
          ===================================================== */}

          <Modal
            show={editForm.show === true}
            onHide={closeEditModal}
            size="lg"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Edit Warehouse</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              {/* Name */}

              <div className="row">
                <div className="col-12 col-md-6">
                  <label className="form-label">
                    Warehouse Name <span className="text-danger">*</span>
                  </label>

                  <input
                    type="text"
                    className={`form-control ${
                      editForm.err?.full_name ? "is-invalid" : ""
                    }`}
                    placeholder="Enter Warehouse Name"
                    name="full_name"
                    value={editForm.full_name || ""}
                    autoComplete="off"
                    onChange={handleEditChange}
                  />

                  {editForm.err?.full_name && (
                    <small className="text-danger">
                      Warehouse name is required.
                    </small>
                  )}
                </div>

                <div className="col-12 col-md-6">
                  <label className="form-label">Warehouse ID</label>

                  <input
                    type="text"
                    className="form-control"
                    value={editForm.warehouse_name || ""}
                    disabled
                  />
                </div>
              </div>

              {/* Pincode */}

              <div className="row mt-3">
                <div className="col-12 col-md-4 mb-3">
                  <label className="form-label">
                    Pincode <span className="text-danger">*</span>
                  </label>

                  <input
                    type="text"
                    className={`form-control ${
                      editForm.err?.pincode ? "is-invalid" : ""
                    }`}
                    placeholder="Enter Pincode"
                    value={editForm.pincode || ""}
                    maxLength={6}
                    onChange={handleEditPincodeChange}
                  />

                  {editForm.err?.pincode && (
                    <small className="text-danger">
                      Please enter a valid 6 digit pincode.
                    </small>
                  )}
                </div>

                <div className="col-6 col-md-4 mb-3">
                  <label className="form-label">State</label>

                  <input
                    type="text"
                    className="form-control"
                    value={editLocation.state || ""}
                    disabled
                  />
                </div>

                <div className="col-6 col-md-4 mb-3">
                  <label className="form-label">City</label>

                  <input
                    type="text"
                    className="form-control"
                    value={editLocation.city || ""}
                    disabled
                  />
                </div>
              </div>

              {/* Address */}

              <div className="row mt-1">
                <div className="col-12">
                  <label className="form-label">
                    Address <span className="text-danger">*</span>
                  </label>

                  <input
                    type="text"
                    className={`form-control ${
                      editForm.err?.address ? "is-invalid" : ""
                    }`}
                    placeholder="Enter Address"
                    name="address"
                    value={editForm.address || ""}
                    autoComplete="off"
                    onChange={handleEditChange}
                  />

                  {editForm.err?.address && (
                    <small className="text-danger">
                      Address must contain house/block/building/street number.
                    </small>
                  )}
                </div>
              </div>

              {/* Email + Mobile */}

              <div className="row mt-3">
                <div className="col-12 col-md-6">
                  <label className="form-label">
                    Email <span className="text-danger">*</span>
                  </label>

                  <input
                    type="email"
                    className={`form-control ${
                      editForm.err?.email ? "is-invalid" : ""
                    }`}
                    placeholder="Enter Email"
                    name="email"
                    value={editForm.email || ""}
                    autoComplete="off"
                    onChange={handleEditChange}
                  />

                  {editForm.err?.email && (
                    <small className="text-danger">
                      Please enter a valid email.
                    </small>
                  )}
                </div>

                <div className="col-12 col-md-6">
                  <label className="form-label">
                    Mobile # <span className="text-danger">*</span>
                  </label>

                  <input
                    type="text"
                    inputMode="numeric"
                    className={`form-control ${
                      editForm.err?.mobile ? "is-invalid" : ""
                    }`}
                    placeholder="Enter Mobile Number"
                    name="mobile"
                    value={editForm.mobile || ""}
                    maxLength={10}
                    autoComplete="off"
                    onChange={handleEditChange}
                  />

                  {editForm.err?.mobile && (
                    <small className="text-danger">
                      Please enter a valid 10 digit mobile number.
                    </small>
                  )}
                </div>
              </div>
            </Modal.Body>

            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={closeEditModal}
                disabled={editLoading}
              >
                Cancel
              </Button>

              <Button
                variant="primary"
                onClick={editAddress}
                disabled={editLoading}
              >
                {editLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                    ></span>
                    Updating...
                  </>
                ) : (
                  "Update Warehouse"
                )}
              </Button>
            </Modal.Footer>
          </Modal>

          {/* =====================================================
              DESKTOP TABLE
          ===================================================== */}

          <div className="card data_table mb-3 mb_display_none">
            <div className="card-body">
              <div className="table-responsive">
                <div className="shipm_tablew rounded-3">
                  <table className="table align-top table-striped table-hover m-0 table-xl">
                    <thead>
                      <tr>
                        <th width="170px">Warehouse Name</th>
                        <th width="200px">Address</th>
                        <th>City</th>
                        <th>Pincode</th>
                        <th>Mobile</th>
                        <th>Email</th>
                        <th>Actions</th>
                      </tr>
                    </thead>

                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="7" className="text-center py-5">
                            <div
                              className="spinner-border text-primary"
                              role="status"
                            ></div>

                            <div className="mt-2">Loading warehouses...</div>
                          </td>
                        </tr>
                      ) : addressState.length === 0 ? (
                        <tr>
                          <td colSpan="7" className="text-center py-5">
                            <div className="mb-2">
                              <i
                                className="bi bi-building"
                                style={{
                                  fontSize: "40px",
                                  color: "#adb5bd",
                                }}
                              ></i>
                            </div>

                            <h5>No Warehouse Found</h5>

                            <p className="text-muted mb-3">
                              Create your first warehouse to get started.
                            </p>

                            <button
                              type="button"
                              className="btn btn-primary"
                              onClick={openCreateModal}
                            >
                              <i className="bi bi-plus"></i> Create Warehouse
                            </button>
                          </td>
                        </tr>
                      ) : (
                        addressState.map((sub, index) => (
                          <tr key={sub.address_id || index}>
                            {/* Warehouse */}

                            <td>
                              <h6 className="mb-1">
                                <a
                                  href="#"
                                  className="text-primary"
                                  onClick={(e) => e.preventDefault()}
                                >
                                  {sub.warehouse_id || sub.full_name || "-"}
                                </a>
                              </h6>

                              <small>ID: {sub.address_id || "-"}</small>

                              {sub.primary === true && (
                                <span className="badge bg-primary ms-2">
                                  Primary
                                </span>
                              )}
                            </td>

                            {/* Address */}

                            <td>{sub.address || "-"}</td>

                            {/* City */}

                            <td>{sub.city_name || "-"}</td>

                            {/* Pincode */}

                            <td>{sub.pincode || "-"}</td>

                            {/* Mobile */}

                            <td>{sub.mobile || "-"}</td>

                            {/* Email */}

                            <td>{sub.email || "-"}</td>

                            {/* Actions */}

                            <td>
                              <div
                                className="warehouse-action-wrapper"
                                style={{
                                  display: "flex",
                                  alignItems: "stretch",
                                  position: "relative",
                                }}
                              >
                                {/* Edit Warehouse */}
                                <button
                                  type="button"
                                  className="warehouse-edit-btn"
                                  onClick={() => setEditAddress(sub)}
                                >
                                  Edit Warehouse
                                </button>

                                {/* Dropdown Button */}
                                <button
                                  type="button"
                                  className="warehouse-dropdown-btn"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    toggleActionMenu(sub.address_id);
                                  }}
                                >
                                  <i className="bi bi-chevron-down"></i>
                                </button>

                                {/* Dropdown Menu */}
                                {openActionId === sub.address_id && (
                                  <div
                                    className="warehouse-action-menu"
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    {!sub.primary && (
                                      <button
                                        type="button"
                                        className="warehouse-menu-item"
                                        onClick={() => {
                                          setAsPrimary(sub.address_id);
                                          setOpenActionId(null);
                                        }}
                                      >
                                        <i className="bi bi-star me-2"></i>
                                        Mark Primary
                                      </button>
                                    )}

                                    <button
                                      type="button"
                                      className="warehouse-menu-item warehouse-delete-item"
                                      onClick={() => {
                                        setOpenActionId(null);
                                        deleteAddressBook(sub.address_id);
                                      }}
                                    >
                                      <i className="bi bi-trash me-2"></i>
                                      Delete Warehouse
                                    </button>
                                  </div>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          {/* =====================================================
              MOBILE VIEW
          ===================================================== */}

          <section className="desk_display_none">
            {loading ? (
              <div className="card mb-3">
                <div className="card-body text-center py-5">
                  <div
                    className="spinner-border text-primary"
                    role="status"
                  ></div>

                  <div className="mt-2">Loading warehouses...</div>
                </div>
              </div>
            ) : addressState.length === 0 ? (
              <div className="card mb-3">
                <div className="card-body text-center py-5">
                  <i
                    className="bi bi-building"
                    style={{
                      fontSize: "40px",
                      color: "#adb5bd",
                    }}
                  ></i>

                  <h5 className="mt-2">No Warehouse Found</h5>

                  <p className="text-muted">
                    Create your first warehouse to get started.
                  </p>

                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={openCreateModal}
                  >
                    <i className="bi bi-plus"></i> Create Warehouse
                  </button>
                </div>
              </div>
            ) : (
              addressState.map((sub, index) => (
                <div className="card mb-3" key={sub.address_id || index}>
                  <div className="card-body">
                    <div className="row">
                      {/* Name */}

                      <div className="col-8 mb-3">
                        <h5 className="mb-1">
                          {sub.warehouse_id || sub.full_name || "-"}
                        </h5>

                        <small>ID: {sub.address_id || "-"}</small>
                      </div>

                      {/* Primary */}

                      <div className="col-4 mb-3 text-end">
                        {sub.primary === true && (
                          <span className="badge bg-primary">Primary</span>
                        )}
                      </div>

                      {/* Address */}

                      <div className="col-12 mb-3">
                        <h6 className="mb-1">Address</h6>

                        <div>{sub.address || "-"}</div>
                      </div>

                      {/* City */}

                      <div className="col-6 mb-3">
                        <h6 className="mb-1">City</h6>

                        <div>{sub.city_name || "-"}</div>
                      </div>

                      {/* Pincode */}

                      <div className="col-6 mb-3">
                        <h6 className="mb-1">Pincode</h6>

                        <div>{sub.pincode || "-"}</div>
                      </div>

                      {/* Mobile */}

                      <div className="col-6 mb-3">
                        <h6 className="mb-1">Mobile</h6>

                        <div>{sub.mobile || "-"}</div>
                      </div>

                      {/* Email */}

                      <div className="col-6 mb-3">
                        <h6 className="mb-1">Email</h6>

                        <div
                          style={{
                            wordBreak: "break-word",
                          }}
                        >
                          {sub.email || "-"}
                        </div>
                      </div>

                      {/* Edit */}

                      <div className="col-6">
                        <div className="d-grid">
                          <button
                            type="button"
                            className="btn btn-primary btn-block"
                            onClick={() => setEditAddress(sub)}
                          >
                            Edit Warehouse
                          </button>
                        </div>
                      </div>

                      {/* Delete */}

                      <div className="col-6">
                        <div className="d-grid">
                          <button
                            type="button"
                            className="btn btn-danger btn-block"
                            onClick={() => deleteAddressBook(sub.address_id)}
                          >
                            Delete Warehouse
                          </button>
                        </div>
                      </div>

                      {/* Mark Primary */}

                      {sub.primary !== true && (
                        <div className="col-12 mt-2">
                          <div className="d-grid">
                            <button
                              type="button"
                              className="btn btn-outline-primary"
                              onClick={() => setAsPrimary(sub.address_id)}
                            >
                              <i className="bi bi-star me-1"></i>
                              Mark as Primary
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))
            )}
          </section>
        </div>
      </Header>

      <Footer />
    </div>
  );
};

export default Warehouse;
